export default __webpack_public_path__ + "static/media/regulatory--weight-limit-per-tandem-axle--g1.e1fb3ce7.png";